import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesNoteConfigRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases-note-config',
	path: '/secure/ConfigureReleaseNote.jspa',
	query: ['projectId', 'version'],
};
